import styled from "styled-components"

import { COLOR } from "ggx-componentlibrary/design/color/color.constants"
import { SPACING } from "ggx-componentlibrary/design/spacing/spacing.constants"

const getBorderColor = (props) => {
  if (props.isDragAccept) {
    return COLOR.BLUE_MEDIUM
  }
  if (props.isDragReject) {
    return COLOR.RED_MEDIUM
  }
  return COLOR.GREY_LIGHT
}

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-radius: ${SPACING.XXS};
  border-color: ${(props) => getBorderColor(props)};
  border-style: dashed;
  background-color: ${COLOR.WHITE};
  transition: border 0.24s ease-in-out;
  height: ${(props) => (props.height ? props.height : "100%")};
  width: ${(props) => (props.width ? props.width : "100%")};
`

export { Container }
